import { Div, Link } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { Icons } from '../Icons';
import { Svg } from '../General/Svg';


export class HelpButton extends Div
{
    constructor(_lang: Translations)
    {
        super("header-button");

        this.Append(
            new Svg(Icons.Hat).Class("header-link-icon"),
            new Link("Help").Html(_lang.Help).Class("header-link")
        );

        this.OnClick(() => window.open("https://tutorial.specteam.pl", "_blank"));
    }
}
